import React, { useState, useRef, useEffect } from 'react';
import api from '../services/api';
//mport { saveMessageToSessionStorage } from '../utils/messageStorage';
import { getTime } from '../utils/mainfunction';
import Loader from "./loader";
import FileUploadPopup from "./fileUpload";
import UserAgreementPopup from "./userAgreement";
import { showInfoAlert, showErrorAlert, showConfirmAndRedirectAlert } from '../utils/alertFunction';
import axios from 'axios';
import ReactDOMServer from 'react-dom/server';
import VoiceInput from './voiceinput';
import VoiceChat, { VoiceChatHandle } from './voicechat';
import { unlockAudioPlayback } from '../services/azureSpeech';
import '../styles/chat.css';
import LinkPopup from './LinkPopup';
import ChatSidebar from './chatSideBar';
import AppointmentCalendar from './appointmentCalendar';
import { getChatHistory } from '../services/chatService';
import { ChatHistoryItem, MessageItem } from '../models/chat';
import { getToken } from '../utils/token';
import { getSpeechLocale, getTexts } from '../utils/i18n';

// Mobil cihaz kontrolü için yardımcı fonksiyon
const isMobileDevice = () => {
    return window.innerWidth <= 768;
};

const Chat: React.FC = () => {
    const texts = getTexts();
    // Sidebar state
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [currentChatId, setCurrentChatId] = useState<string>('');
    const [hasChatHistory, setHasChatHistory] = useState(false);
    const isInitialLoadRef = useRef(true); // İlk yükleme kontrolü için

    const [isAgreementAccepted, setIsAgreementAccepted] = useState(false);
    const [messages, setMessages] = useState<MessageItem[]>([]);
    const [messageInput, setMessageInput] = useState(''); // Kullanıcının yazdığı mesaj
    const messageBoxRef = useRef<HTMLDivElement>(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isPopupVisible, setPopupVisible] = useState(false);
    const [isListening, setIsListening] = useState(false);
    const [showScrollTop, setShowScrollTop] = useState(false);
    const [isLinkPopupVisible, setLinkPopupVisible] = useState(false);
    const [currentLinkUrl, setCurrentLinkUrl] = useState('');
    const [isVoiceChatActive, setIsVoiceChatActive] = useState(false);
    const voiceChatRef = useRef<VoiceChatHandle>(null);
    const explicitChatSelectionRef = useRef(false); // Sidebar'dan kullanıcının bilinçli seçimi mi?
    // Aktif sohbet her değiştiğinde (yeni sohbet, sohbet değiştirme, silme) artar.
    // Geç gelen (stale) bir API yanıtının artık aktif olmayan bir sohbete yazılmasını engellemek için kullanılır.
    const chatSessionIdRef = useRef(0);

    useEffect(() => {
        // 1. Sayfa ilk açıldığında localStorage'dan oku

        const agreementAccepted = localStorage.getItem("AgreementApprovalChat") === "true";
        setIsAgreementAccepted(agreementAccepted);

        // 2. Başka sekmeden localStorage değişirse dinle
        const handleStorageChange = () => {
            const updated = localStorage.getItem("AgreementApprovalChat") === "true";
            setIsAgreementAccepted(updated);
        };

        window.addEventListener('storage', handleStorageChange);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
        };
    }, []);

    // Chat geçmişi değiştiğinde sidebar'ı otomatik aç (sadece ilk yüklemede, web'de ve login ise)
    const handleChatHistoryLoaded = (hasHistory: boolean) => {
        setHasChatHistory(hasHistory);

        // Sadece ilk yüklemede sidebar'ı otomatik aç
        if (isInitialLoadRef.current) {
            const token = getToken();
            const isLoggedIn = !!token;

            // Sadece web görünümünde, login ise ve chat geçmişi varsa sidebar'ı aç
            if (!isMobileDevice() && isLoggedIn && hasHistory) {
                setIsSidebarOpen(true);
            }
            isInitialLoadRef.current = false; // İlk yükleme tamamlandı
        }
    };

    // Ekran boyutu değişikliğinde sidebar durumunu kontrol et
    useEffect(() => {
        const handleResize = () => {
            const token = getToken();
            const isLoggedIn = !!token;

            // Mobil cihaza geçildiğinde sidebar'ı kapat
            if (isMobileDevice()) {
                setIsSidebarOpen(false);
            }
            // Web'e geçildiğinde ve koşullar uygunsa sidebar'ı aç
            else if (isLoggedIn && hasChatHistory) {
                setIsSidebarOpen(true);
            }
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [hasChatHistory]);

    useEffect(() => {
        if (isAgreementAccepted) {
            handleStartChat();
        }
    }, [isAgreementAccepted]);


    useEffect(() => {
        const getChatHistory = async () => {

            // Sadece kullanıcı sidebar'dan bilinçli olarak bir sohbet seçtiyse çalış.
            // Aksi halde (örn. sidebar'ın ilk yüklemede otomatik seçimi) aktif sohbetin
            // mesajlarını ve GUID'ini eski bir sohbetle ezmiş oluruz.
            if (!explicitChatSelectionRef.current) return;
            explicitChatSelectionRef.current = false;

            const isChatStarted = sessionStorage.getItem('isChatStarted');

            // Eğer chat hiç başlatılmamışsa veya guid yoksa çık

            if (!isChatStarted) return;
            try {
                const response = await api.get('/api/Chat/GetChatHistory');
                if (response.data && response.data.chatList.length > 0) {

                    const chatHistory = response.data.chatList;
                    const filteredChat = chatHistory.find((msg: any) => msg.guid === currentChatId);

                    if (!filteredChat) return;

                    sessionStorage.setItem("chatGuid", currentChatId);

                    setMessages(filteredChat.history.map((msg: ChatHistoryItem) => ({

                        userMessage: msg.userMessage,
                        isUser: msg.isUser,
                        buttons: msg.buttons || [],
                        images: msg.images || [],
                        response: msg.response,
                        type: msg.type,
                        slots: msg.slots || [],
                        horizontal_list: msg.horizontal_list || [],

                    })));



                }
            } catch (error) {
                console.error('Chat geçmişi yüklenirken hata oluştu:', error);
            }
        }
        getChatHistory();
    }, [currentChatId]);




    // Sidebar handlers
    const handleSidebarToggle = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    const handleSelectChat = (chatId: string) => {
        chatSessionIdRef.current += 1;
        explicitChatSelectionRef.current = true;
        setCurrentChatId(chatId);
        setIsSidebarOpen(false); // Close sidebar after selection
        // Here you would typically load the chat history for the selected chat
        console.log('Selected chat:', chatId);
    };

    const handleNewChat = () => {

        chatSessionIdRef.current += 1;
        setCurrentChatId('');
        setMessages([]);
        setMessageInput('');
        setIsSidebarOpen(false);
        // Reset session storage for new chat
        sessionStorage.removeItem('chatGuid');
        sessionStorage.removeItem('botType');
        handleStartChat();
    };

    const handleDeleteChat = (chatId: string) => {
        if (currentChatId === chatId) {
            chatSessionIdRef.current += 1;
            setMessages([]);
            setCurrentChatId('');
            sessionStorage.removeItem('chatGuid');
        }
    };

    // Web Speech API için recognition nesnesini oluşturalım
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    const recognition = SpeechRecognition ? new SpeechRecognition() : null;

    useEffect(() => {
        if (recognition) {
            recognition.continuous = true;
            recognition.interimResults = true;
            recognition.lang = getSpeechLocale();

            recognition.onresult = (event: any) => {
                const transcript = event.results[0][0].transcript;
                console.log("Algılanan metin:", transcript);
                setMessageInput(transcript); // Input'a yaz
                if (event.results[0].isFinal) { // Konuşma bittiğinde
                    sendMessage(transcript); // Mesajı otomatik gönder
                }
            };

            recognition.onerror = (event: any) => {
                console.error('Ses tanıma hatası:', event.error);
                setIsListening(false);
            };

            recognition.onend = () => {
                setIsListening(false);
            };
        }
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            if (messageBoxRef.current) {
                const { scrollTop } = messageBoxRef.current;
                setShowScrollTop(scrollTop > 300);
            }
        };

        const messageBox = messageBoxRef.current;
        if (messageBox) {
            messageBox.addEventListener('scroll', handleScroll);
        }

        return () => {
            if (messageBox) {
                messageBox.removeEventListener('scroll', handleScroll);
            }
        };
    }, []);

    const handleOpenPopup = () => setPopupVisible(true);
    const handleClosePopup = () => setPopupVisible(false);

    const handleUploadSuccess = (file: File) => {
        console.log("Yükleme başarılı:", file.name);


        const userMessage = {
            userMessage: texts.uploadSuccess(file.name),
            isUser: true,
            buttons: [],
            images: [],
            response: '',
            type: 0,
            slots: [],
            horizontal_list: []
        }
        setMessages((prevMessages) => [...prevMessages, userMessage]);


        //setMessages((prevMessages) => [...prevMessages, newMessage]);


        const aiMessage = {
            userMessage: '',
            isUser: false,
            buttons: [],
            images: [],
            response: texts.uploadSuccessReply,
            type: 0,
            slots: [],
            horizontal_list: []
        }
        setMessages((prevMessages) => [...prevMessages, aiMessage]);
    };

    const handleButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        const action = event.currentTarget.getAttribute('data-action');

        if (action) {
            sendMessage(action);
            console.log(`Buton renkli tıklandı: ${action}`);
        }
    };

    // itemType 3 (evde sağlık yorum) butonları için: birden fazla öğe ve geçerli bir id varsa "buttonTitle - id" olarak gönder
    const getReviewItemAction = (item: { buttonTitle: string; id?: string }, items: { buttonTitle: string; id?: string }[]) => {
        return items.length > 1 && item.id ? `${item.buttonTitle} - ${item.id}` : item.buttonTitle;
    };

    // AppointmentCalendar için özel buton click handler
    const handleAppointmentButtonClick = (dateStr: string, time: string) => {
        // Kullanıcıya gösterilecek mesaj

        const displayMessage = `${dateStr} ${time}`;
        console.log('Gelen veriler:', { dateStr, time });
        sendMessage(displayMessage);


        console.log(`Randevu seçildi: ${displayMessage}`);
    };


    const sendMessage = async (eventOrMessage?: React.MouseEvent<HTMLButtonElement> | string, apiMessage?: string, isAppointmentSlot?: boolean): Promise<string | undefined> => {
        // Sözleşme onayı kontrolü
        if (!isAgreementAccepted) {
            showInfoAlert(texts.info, texts.agreementRequired);
            return undefined;
        }

        // GUID kontrolü ekleyelim
        const chatGuid = sessionStorage.getItem('chatGuid');
        if (!chatGuid) {
            showInfoAlert(texts.info, texts.selectCategoryFirst);
            return undefined;
        }

        // Bu istek gönderilirken aktif olan sohbet neslini kaydet.
        // Yanıt geldiğinde sohbet değişmişse (yeni sohbet/sohbet değiştirme/silme) bu yanıtı yok sayacağız.
        const sessionIdAtSend = chatSessionIdRef.current;

        let message = "";
        const wasVoiceUsed = (window as any).wasVoiceInput; // Mevcut durumu kaydet

        // Eğer event geldiyse `messageInput` kullanılır, string geldiyse direkt o mesaj
        if (typeof eventOrMessage === "string") {
            message = eventOrMessage;
        } else {
            message = messageInput.trim();
        }

        if (!message) return;

        // Her mesaj gönderiminde ses girişi durumunu sıfırla
        if (typeof window !== 'undefined') {
            (window as any).wasVoiceInput = false;
        }

        setIsLoading(true);

        const userMessage = {
            userMessage: message,
            isUser: true,
            buttons: [],
            images: [],
            response: '',
            type: 0,
            slots: [],
            horizontal_list: []
        }
        setMessages((prevMessages) => [...prevMessages, userMessage]);

        setMessageInput('');
        setTimeout(() => {
            scrollToBottom();
        }, 200);

        try {
            // API'ye gönderilecek mesajı belirle
            const messageToSend = isAppointmentSlot && apiMessage ? apiMessage : message;

            const response = await api.post('/api/Chat/SendMessage', {
                newmessage: messageToSend,
                botType: sessionStorage.getItem('botType'),
                GUID: sessionStorage.getItem('chatGuid')
            });

            // Yanıt gelene kadar kullanıcı yeni bir sohbete geçtiyse/başlattıysa
            // bu geç kalmış yanıtı mevcut (alakasız) sohbete yazmadan çık.
            if (chatSessionIdRef.current !== sessionIdAtSend) {
                return response.data?.response ? response.data.response.replace(/<[^>]*>/g, '') : undefined;
            }

            if (response.data.responseStatus) {

                let combinedContent: JSX.Element;
                sessionStorage.setItem('isChatStarted', 'true');
                // type 9 kontrolü ve diğer durumlar için güncelleme
                setInputsDisabled(response.data.type === 9);

                const aiMessageContent = response.data.response;
                // HTML etiketlerini temizle
                //const plainText = aiMessageContent.replace(/<[^>]*>/g, '');
                const plainText = aiMessageContent ? aiMessageContent.replace(/<[^>]*>/g, '') : '';

                // Diğer type kontrolleri
                if (response.data.type === 8) {
                    sessionStorage.clear();
                    window.location.reload();
                    return;
                }
                else if (response.data.type === 15) {
                    setTimeout(() => handleOpenPopup(), 500);
                    return;
                }
                else if (response.data.type === 12) {
                    sessionStorage.clear();
                    window.location.href = "https://www.happ.health/";
                    return;
                }


                // wasVoiceInput kontrolünü messageInput'tan al
                if (wasVoiceUsed) {  // wasVoiceUsed kullan
                    setTimeout(() => {
                        if (window.speechSynthesis && plainText) {
                            const utterance = new SpeechSynthesisUtterance(plainText);
                            utterance.lang = getSpeechLocale();
                            window.speechSynthesis.speak(utterance);
                        }
                    }, 500);
                }

                const userMessage = {
                    userMessage: null,
                    isUser: response.data.isUser,
                    buttons: response.data.buttons || [],
                    images: response.data,
                    response: response.data.response,
                    type: response.data.type,
                    slots: response.data.slots,
                    horizontal_list: response.data.horizontal_list || [],
                }

                setMessages((prevMessages) => [...prevMessages, userMessage]);


                if (response.data.type === 5) {
                    combinedContent = (
                        <div>
                            <AppointmentCalendar
                                scheduleData={response.data.doctorSlots}
                                messageType={0}
                                onAppointmentSelect={handleAppointmentButtonClick}
                            />
                        </div>
                    );
                    var contentString = ReactDOMServer.renderToString(combinedContent);



                }
                else if (response.data.type === 11) {

                    const items = response.data.horizontal_list as any[];

                    //const items = response.data.horizontalList;
                    const liste = items.filter(item => item.itemType === 1);
                    const dahaFazla = items.find(item => item.itemType === 2);
                    const yorumlar = items.filter(item => item.itemType === 3);

                    const buttonElements = liste.map((item, idx) => (
                        <div
                            key={idx}
                            className="doctor-card"
                        >
                            <img
                                src={
                                    item.imageUrl || 'https://imagedelivery.net/mlgbP0181FH-5b9hEejSQw/6f3364b4-81c6-41be-8596-dc4250b5f000/public'
                                }
                                alt={item.title}
                                style={{
                                    width: '100%',
                                    height: '160px',
                                    objectFit: 'contain',
                                }}
                            />

                            <div style={{ padding: '10px' }}>
                                <div style={{ fontWeight: '600', fontSize: '14px', marginBottom: '12px', height: '40px', overflow: 'hidden' }}>
                                    {item.title}
                                </div>

                                <button
                                    data-action={item.title}
                                    onClick={handleButtonClick}
                                    className="horizontal-div-btn"
                                >
                                    {item.buttonTitle}
                                </button>
                            </div>
                        </div>
                    ));

                    const reviewElements = yorumlar.map((item, idx) => (
                        <div
                            key={`yorum-${idx}`}
                            className="doctor-card"
                        >
                            <img
                                src={
                                    item.imageUrl || 'https://imagedelivery.net/mlgbP0181FH-5b9hEejSQw/6f3364b4-81c6-41be-8596-dc4250b5f000/public'
                                }
                                alt={item.title}
                                style={{
                                    width: '100%',
                                    height: '160px',
                                    objectFit: 'contain',
                                }}
                            />

                            <div style={{ padding: '10px' }}>
                                <div style={{ fontWeight: '600', fontSize: '14px', marginBottom: '12px', height: '40px', overflow: 'hidden' }}>
                                    {item.title}
                                </div>

                                <button
                                    data-action={getReviewItemAction(item, yorumlar)}
                                    onClick={handleButtonClick}
                                    className="horizontal-div-btn"
                                >
                                    {item.buttonTitle}
                                </button>
                            </div>
                        </div>
                    ));

                    const lastButtonElement = dahaFazla ? (
                        <span
                            key="daha-fazla"
                            data-action={dahaFazla.buttonTitle}
                            onClick={handleButtonClick}
                            className="horizontal-div-bottom-btn"
                        >
                            {dahaFazla.buttonTitle}
                        </span>
                    ) : null;

                    combinedContent = (
                        <div>
                            {/* Burada response metni basılıyor */}
                            <p style={{ fontSize: '15px', fontWeight: 500, marginBottom: '12px' }}>
                                {response.data.response}
                            </p>

                            <div

                                className="scroll-wrapper w-100 scroll-wrapper-custom"
                            >
                                {buttonElements}
                                {reviewElements}
                            </div>

                            {lastButtonElement}
                        </div>
                    );


                    const contentString = ReactDOMServer.renderToString(combinedContent);


                }
                else if (response.data.buttons && response.data.buttons.length > 0) {
                    const renkler = ['blue', 'orange', 'green'];
                    // const isImageTypeWithMoreButton = response.data.type === 11;
                    // const isImageType = response.data.type === 10;
                    let buttonElements;


                    buttonElements = response.data.buttons.map((button: { title: string }, idx: number) => (
                        <button
                            key={button.title}
                            data-action={button.title}
                            onClick={handleButtonClick}
                            className={`sabit-btn ${renkler[idx % 3]}`}
                        >
                            {button.title}
                        </button>
                    ));

                    combinedContent = (
                        <div>
                            <p>{response.data.response}</p>
                            <div>{buttonElements}</div>
                        </div>
                    );







                }


                if (response.data.isFileNotUploaded) {
                    const aiMessage = { sender: 'ai', text: response.data.responseMessage, time: getTime() };
                    // setMessages((prevMessages) => [...prevMessages, aiMessage]);

                    setTimeout(() => {
                        handleOpenPopup();
                    }, 2000);
                }

                return plainText;
            }
            else {

                showInfoAlert(texts.info, response.data.responseMessage);

            }
        }
        catch (error: any) {

            if (error?.response?.status === 403) {
                showConfirmAndRedirectAlert(
                    texts.loginRequiredTitle,
                    texts.loginRequiredText,
                    texts.yes,
                    texts.no,
                    'https://www.happ.health/ai/chat/login'
                );
            } else if (error?.response?.status === 401) {
                showErrorAlert(texts.error, texts.sessionExpired);
            } else {
                showErrorAlert(texts.error, texts.unknownError);
            }
        } finally {
            setIsLoading(false);
        }

        setTimeout(() => {
            scrollToBottom();
        }, 500);

        return undefined;
    };

    // Chat ekranını aşağı kaydır
    const scrollToBottom = () => {

        if (messageBoxRef.current) {
            messageBoxRef.current.scrollTop = messageBoxRef.current.scrollHeight;
        }
    };


    const toggleListening = () => {
        if (!recognition) {
            showErrorAlert(texts.error, texts.speechNotSupported);
            return;
        }

        if (isListening) {
            recognition.stop();
        } else {
            recognition.start();
        }
        setIsListening(!isListening);
    };

    const handleTranscript = (text: string) => {
        setMessageInput(text);
    };

    // Sesli sohbet aktifken yazarak gonderilen mesaj: devam eden okumayi keser
    // ve mesaji ayni sesli sohbet akisina (dusun -> yanitla -> oku) sokar.
    const handleTypedSend = () => {
        if (!messageInput.trim()) return;

        if (isVoiceChatActive) {
            voiceChatRef.current?.interruptWithText(messageInput);
            setMessageInput('');
        } else {
            sendMessage();
        }
    };

    const handleStartChat = async () => {
        // Sözleşme onayı kontrolü
        if (!isAgreementAccepted) {
            showInfoAlert(texts.info, texts.agreementRequired);
            return;
        }

        const sessionIdAtSend = chatSessionIdRef.current;

        try {
            const response = await api.post('/api/Chat/StartChat');

            // Yanıt gelene kadar sohbet tekrar değiştiyse (örn. art arda "Yeni Sohbet"e
            // basıldıysa) bu geç kalmış yanıtı uygulamadan çık.
            if (chatSessionIdRef.current !== sessionIdAtSend) {
                return;
            }

            // Guid'i kaydet
            if (response.data.guid) {
                sessionStorage.setItem('chatGuid', response.data.guid);
            }

            if (response.data.responseStatus) {
                // Type 9 kontrolü ekle
                setInputsDisabled(response.data.type === 9);

                const aiMessageContent = response.data.response;

                // AI yanıtını sesli oku (eğer ses girişi kullanıldıysa)
                if ((window as any).wasVoiceInput && (window as any).speakResponse) {
                    const plainText = aiMessageContent.replace(/<[^>]*>/g, '');
                    (window as any).speakResponse(plainText);
                }

                if (response.data.buttons && response.data.buttons.length > 0) {
                    const renkler = ['blue', 'orange', 'green'];
                    const buttonElements = response.data.buttons.map((button: { title: string }, idx: number) => (
                        <button
                            key={button.title}
                            data-action={button.title}
                            onClick={handleButtonClick}
                            className={`sabit-btn ${renkler[idx % 3]}`}
                        >
                            {button.title}
                        </button>
                    ));

                    const combinedContent = (
                        <div>
                            <p>{response.data.response}</p>
                            <div>{buttonElements}</div>
                        </div>
                    );


                }

                const aiMessage = {
                    userMessage: null,
                    isUser: false,
                    buttons: response.data.buttons || [],
                    images: response.data.images || [],
                    response: aiMessageContent,
                    type: response.data.type,
                    slots: response.data.slots || [],
                    horizontal_list: response.data.horizontal_list || [],
                };

                setMessages((prevMessages) => [...prevMessages, aiMessage]);

            } else {
                showInfoAlert(texts.info, response.data.responseMessage);
            }
        } catch (error: any) {

            if (error?.response?.status === 403) {
                showConfirmAndRedirectAlert(
                    texts.loginRequiredTitle,
                    texts.loginRequiredText,
                    texts.yes,
                    texts.no,
                    'https://www.happ.health/ai/chat/login'
                );
            } else if (error?.response?.status === 401) {
                showErrorAlert(texts.error, texts.sessionExpired);
            } else {
                showErrorAlert(texts.error, texts.unknownError);
            }
        }
    };

    const scrollToTop = () => {
        if (messageBoxRef.current) {
            messageBoxRef.current.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    };

    const [inputsDisabled, setInputsDisabled] = useState(false);

    // setInputsDisabled'ı global olarak erişilebilir yap
    useEffect(() => {
        if (typeof window !== 'undefined') {
            (window as any).setInputsDisabled = setInputsDisabled;
        }
        return () => {
            if (typeof window !== 'undefined') {
                delete (window as any).setInputsDisabled;
            }
        };
    }, []);

    const handleLinkClick = (url: string) => {
        setCurrentLinkUrl(url);
        setLinkPopupVisible(true);
    };

    // Bot mesajlari dangerouslySetInnerHTML ile basildigi icin icindeki <a>
    // tiklamalarini yakalayip sayfadan cikmak yerine LinkPopup (iframe) icinde acar.
    const handleBotMessageClick = (e: React.MouseEvent<HTMLDivElement>) => {
        const anchor = (e.target as HTMLElement).closest('a');
        if (anchor && anchor.href) {
            e.preventDefault();
            handleLinkClick(anchor.href);
        }
    };

    const handleCloseLinkPopup = () => {
        setLinkPopupVisible(false);
        setCurrentLinkUrl('');
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            (window as any).handleLinkClick = handleLinkClick;
        }
        return () => {
            if (typeof window !== 'undefined') {
                delete (window as any).handleLinkClick;
            }
        };
    }, []);

    return (
        <div className="chat-layout">
            {/* Sidebar */}
            <ChatSidebar
                isOpen={isSidebarOpen}
                onToggle={handleSidebarToggle}
                onSelectChat={handleSelectChat}
                onNewChat={handleNewChat}
                onDeleteChat={handleDeleteChat}
                currentChatId={currentChatId}
                setCurrentChatId={setCurrentChatId}
                onChatHistoryLoaded={handleChatHistoryLoaded}
            />

            {/* Main Chat Area */}
            <div className={`chat-main-area ${isSidebarOpen ? 'sidebar-open' : ''}`}>

                <div id="chat-container" >
                    <div className="card border-0 h-100">
                        <div className="chat-topbar">
                            <div className="chat-topbar-left">
                                {/* Hamburger Menu Button */}
                                <button
                                    onClick={handleSidebarToggle}
                                    className="chat-topbar-menu"
                                    aria-label={isSidebarOpen ? texts.closeSidebar : texts.openSidebar}
                                >
                                    <span style={{ fontSize: '16px' }}>☰</span>
                                </button>

                                <img src="https://imagedelivery.net/mlgbP0181FH-5b9hEejSQw/741384eb-f43d-407b-7f26-d48bcb1f3100/public" alt="HappAI Logo" className="chat-topbar-logo" />
                                <div>
                                    <span className="chat-topbar-title">HappAI</span>
                                    <span className="chat-topbar-status"><span className="dot"></span>Sağlık asistanı · çevrimiçi</span>
                                </div>
                            </div>
                            <button className="chat-topbar-close" onClick={() => window.top ? window.top.location.href = "https://www.happ.health" : window.location.href = "https://www.happ.health"} aria-label={texts.close}>
                                <span style={{ fontWeight: 600, fontSize: '1.1rem' }}>×</span>
                            </button>

                        </div>
                        <div ref={messageBoxRef} className="card-body p-3 pb-5 chat-body" id="chat-messagebox-body" >
                            <div id="chat-messagebox-body">

                                {messages.map((msg, index) => (

                                    <div
                                        key={index}
                                        className={`d-flex mb-3 ${msg.isUser === true ? 'justify-content-end text-end' : 'justify-content-start'}`}
                                    >
                                        {/* {msg.isFile ? (
                                                <div className={`d-flex align-items-baseline mb-4 message ${msg.sender === 'user' ? 'user' : 'chat'}`}
                                                >
                                                    <div className="pe-2">
                                                        <div>
                                                            <div className="chat-bubble user flex">
                                                                <div className="file-icon png">
                                                                    <i className="far fa-file-image" aria-hidden="true"></i>
                                                                </div>
                                                                <div className="file-info">
                                                                    <span className="file-name">{msg.fileName}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <div className="chat-time">{msg.time}</div>
                                                        </div>
                                                    </div>

                                                </div>
                                            ) : (

                                                <div className={`d-flex align-items-baseline message ${msg.isHorizontalScroll === true ? 'w-100' : ''}`}
                                                >
                                                    <div className={`pe-2 ${msg.isHorizontalScroll === true ? 'w-100' : ''}`}>
                                                        {typeof msg.text === 'string' ? (
                                                            <div
                                                                className={`chat-bubble  ${msg.isHorizontalScroll === true ? 'w-100' : ''}  ${msg.sender === 'user' ? 'user' : 'bot'}`}
                                                                dangerouslySetInnerHTML={{ __html: msg.text }}
                                                            ></div>
                                                        ) : (
                                                            <div className={`chat-bubble ${msg.isHorizontalScroll === true ? 'w-100' : ''} ${msg.sender === 'user' ? 'user' : 'bot'}`}>
                                                                {msg.text}
                                                            </div>
                                                        )}
                                                      
                                                    </div>

                                                </div>
                                            )} */}


                                        {msg.isUser ? (
                                            <div className="d-flex align-items-baseline mb-4 message user">
                                                <div className="pe-2">
                                                    <div className="chat-bubble user">{msg.userMessage}</div>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="d-flex align-items-baseline mb-4 message bot w-100">
                                                <div className="pe-2 w-100">
                                                    {msg.type === 5 && (
                                                        <div className="chat-bubble bot w-100">
                                                            <AppointmentCalendar
                                                                scheduleData={msg.slots}
                                                                messageType={0}
                                                                onAppointmentSelect={handleAppointmentButtonClick}
                                                            />
                                                        </div>
                                                    )}

                                                    {msg.type === 11 && (
                                                        <div className="chat-bubble bot w-100">
                                                            <p style={{ fontSize: '15px', fontWeight: 500, marginBottom: '12px' }}>
                                                                {msg.response}
                                                            </p>
                                                            <div className="scroll-wrapper w-100 scroll-wrapper-custom">
                                                                {msg.horizontal_list
                                                                    .filter(item => item.itemType === 1)
                                                                    .map((item, idx) => (
                                                                        <div key={idx} className="doctor-card">
                                                                            <img
                                                                                src={item.imageUrl || 'https://imagedelivery.net/mlgbP0181FH-5b9hEejSQw/6f3364b4-81c6-41be-8596-dc4250b5f000/public'}
                                                                                alt={item.title}
                                                                                style={{
                                                                                    width: '100%',
                                                                                    height: '160px',
                                                                                    objectFit: 'contain',
                                                                                }}
                                                                            />
                                                                            <div style={{ padding: '10px' }}>
                                                                                <div style={{ fontWeight: '600', fontSize: '14px', marginBottom: '12px', height: '40px', overflow: 'hidden' }}>
                                                                                    {item.title}
                                                                                </div>
                                                                                <button
                                                                                    data-action={item.title}
                                                                                    onClick={handleButtonClick}
                                                                                    className="horizontal-div-btn"
                                                                                >
                                                                                    {item.buttonTitle}
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                {(() => {
                                                                    const yorumlar = msg.horizontal_list.filter(item => item.itemType === 3);
                                                                    return yorumlar.map((item, idx) => (
                                                                        <div key={`yorum-${idx}`} className="doctor-card">
                                                                            <img
                                                                                src={item.imageUrl || 'https://imagedelivery.net/mlgbP0181FH-5b9hEejSQw/6f3364b4-81c6-41be-8596-dc4250b5f000/public'}
                                                                                alt={item.title}
                                                                                style={{
                                                                                    width: '100%',
                                                                                    height: '160px',
                                                                                    objectFit: 'contain',
                                                                                }}
                                                                            />
                                                                            <div style={{ padding: '10px' }}>
                                                                                <div style={{ fontWeight: '600', fontSize: '14px', marginBottom: '12px', height: '40px', overflow: 'hidden' }}>
                                                                                    {item.title}
                                                                                </div>
                                                                                <button
                                                                                    data-action={getReviewItemAction(item, yorumlar)}
                                                                                    onClick={handleButtonClick}
                                                                                    className="horizontal-div-btn"
                                                                                >
                                                                                    {item.buttonTitle}
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    ));
                                                                })()}
                                                            </div>

                                                            {msg.horizontal_list?.find(item => item.itemType === 2) && (
                                                                <span
                                                                    data-action={msg.horizontal_list?.find(item => item.itemType === 2)?.buttonTitle}
                                                                    onClick={handleButtonClick}
                                                                    className="horizontal-div-bottom-btn"
                                                                >
                                                                    {msg.horizontal_list?.find(item => item.itemType === 2)?.buttonTitle}
                                                                </span>
                                                            )}
                                                        </div>
                                                    )}

                                                    {msg.buttons && msg.buttons.length > 0 && (
                                                        <div className="chat-bubble bot">
                                                            <p>{msg.response}</p>
                                                            <div>
                                                                {msg.buttons.map((button, idx) => {
                                                                    const renkler = ['blue', 'orange', 'green'];
                                                                    return (
                                                                        <button
                                                                            key={button.title}
                                                                            data-action={button.title}
                                                                            onClick={handleButtonClick}
                                                                            className={`sabit-btn ${renkler[idx % 3]}`}
                                                                        >
                                                                            {button.title}
                                                                        </button>
                                                                    );
                                                                })}
                                                            </div>
                                                        </div>
                                                    )}

                                                    {msg.type !== 5 && msg.type !== 11 && (!msg.buttons || msg.buttons.length === 0) && (
                                                        <div className="chat-bubble bot">
                                                            {typeof msg.response === 'string' ? (
                                                                <div onClick={handleBotMessageClick} dangerouslySetInnerHTML={{ __html: msg.response }} />
                                                            ) : (
                                                                msg.response
                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        )}





                                    </div>
                                ))}
                                {isLoading && <Loader />}
                            </div>
                        </div>

                        <FileUploadPopup
                            isVisible={isPopupVisible}
                            onClose={handleClosePopup}
                            onUploadSuccess={handleUploadSuccess}
                        />
                        <UserAgreementPopup />
                        <LinkPopup
                            isVisible={isLinkPopupVisible}
                            onClose={handleCloseLinkPopup}
                            url={currentLinkUrl}
                        />

                        <div className="position-fixed card-footer bg-white position-absolute w-100 bottom-0 m-0 p-1" >
                            <div className="chat-inputbar">
                                <button onClick={handleOpenPopup} className="chat-inputbar-file" type="button" disabled={isVoiceChatActive}>
                                    <img src="https://imagedelivery.net/mlgbP0181FH-5b9hEejSQw/06aed643-d5a2-4deb-9693-9dbf632e4700/public" alt={texts.sendFile} />
                                </button>
                                <input
                                    type="text"
                                    className="chat-inputbar-input"
                                    placeholder={texts.writeMessage}
                                    value={messageInput}
                                    onChange={(e) => setMessageInput(e.target.value)}
                                    onKeyPress={(e) => e.key === 'Enter' && handleTypedSend()}
                                    disabled={inputsDisabled}
                                />
                                <div className="chat-inputbar-icons">
                                    <VoiceInput
                                        onTranscript={handleTranscript}
                                        disabled={inputsDisabled || isVoiceChatActive}
                                    />
                                    <button
                                        className="chat-inputbar-iconbtn"
                                        title={texts.voiceChat}
                                        type="button"
                                        disabled={inputsDisabled}
                                        aria-pressed={isVoiceChatActive}
                                        onClick={() => {
                                            unlockAudioPlayback();
                                            setIsVoiceChatActive(prev => !prev);
                                        }}
                                    >
                                        <img src="/images/ses_ikonu.svg" alt={texts.voiceChat} width="24" height="24" />
                                    </button>
                                    <button
                                        onClick={handleTypedSend}
                                        className="chat-inputbar-iconbtn"
                                        disabled={inputsDisabled}
                                        type="button"
                                    >
                                        <img src="/images/send-icon.svg" alt={texts.send} />
                                    </button>
                                </div>
                            </div>
                        </div>

                        <VoiceChat
                            ref={voiceChatRef}
                            isActive={isVoiceChatActive}
                            onClose={() => setIsVoiceChatActive(false)}
                            sendMessage={sendMessage}
                        />

                        <button
                            className={`scroll-to-top ${showScrollTop ? 'visible' : ''}`}
                            onClick={scrollToTop}
                            title={texts.scrollTop}
                        >
                            <i className="fas fa-arrow-up"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Chat;
